import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5297ee62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row p-2 nav" }
const _hoisted_2 = { class: "col-12 d-flex h-100 flex-column" }
const _hoisted_3 = {
  class: "nav nav-tabs",
  id: "logTabs",
  role: "tablist"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "nav-item",
  role: "presentation"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "nav-link active",
    id: "logs-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#logs",
    type: "button",
    role: "tab",
    "aria-controls": "logs",
    "aria-selected": "true"
  }, " Current Logs ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "nav-item",
  role: "presentation"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "nav-link",
    id: "previous-logs-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#previous-logs",
    type: "button",
    role: "tab",
    "aria-controls": "previous-logs",
    "aria-selected": "false"
  }, " Previous Logs ")
], -1))
const _hoisted_6 = {
  class: "nav-item p-2 ms-auto",
  role: "presentation"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "autoScrollLogsCheckbox" }, "automatically scroll to last line", -1))
const _hoisted_9 = {
  class: "tab-pane show active",
  id: "logs",
  role: "tabpanel",
  "aria-labelledby": "logs-tab"
}
const _hoisted_10 = {
  class: "list-group",
  id: "currentLogList"
}
const _hoisted_11 = {
  class: "tab-pane",
  id: "previous-logs",
  role: "tabpanel",
  "aria-labelledby": "previous-logs-tab"
}
const _hoisted_12 = {
  class: "list-group",
  id: "previousLogList"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("li", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "autoScrollLogsCheckbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.autoScrollLogsToLatest) = $event))
          }, null, 512), [
            [
              _vModelCheckbox,
              _ctx.autoScrollLogsToLatest,
              void 0,
              { number: true }
            ]
          ]),
          _hoisted_7,
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", {
        class: "tab-content flex-fill overflow-auto",
        id: "logTabsContent",
        onWheel: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.disableLogScrolling && _ctx.disableLogScrolling(...args)))
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.currentLog, (line) => {
              return (_openBlock(), _createElementBlock("li", {
                key: line,
                class: _normalizeClass(["list-group-item", _ctx.classForLine(line)])
              }, _toDisplayString(line), 3))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("ul", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.previousLog, (line) => {
              return (_openBlock(), _createElementBlock("li", {
                key: line,
                class: _normalizeClass(["list-group-item", _ctx.classForLine(line)])
              }, _toDisplayString(line), 3))
            }), 128))
          ])
        ])
      ], 32)
    ])
  ]))
}